module.exports = __webpack_public_path__ + "inputs/img/nmg.978a3d27.png";